import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _hoisted_1 = { class: "opModal formContainer uploadExcelModal" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-sm-12" }
const _hoisted_10 = { class: "text-center mt-4" }
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Create bottom underwear config",
          text: "Create bottom underwear config"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_form_field, {
              type: "file",
              modelValue: _ctx.file,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.file) = $event)),
              fileName: _ctx.file ? _ctx.file.name : '',
              labelKey: "Excel file",
              labelValue: "Excel file"
            }, null, 8, ["modelValue", "fileName"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          disabled: !_ctx.file,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.uploadFile()))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Upload",
            text: "Upload"
          })
        ], 8, _hoisted_11)
      ])
    ])
  ]))
}